import { render, staticRenderFns } from "./AccountPairCreateOrUpdate.vue?vue&type=template&id=15a53121&"
import script from "./AccountPairCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AccountPairCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports